<template>
	<aside class="c-newsletter" aria-label="Newsletter">
		<div class="c-newsletter__wrapper">
			<div class="c-newsletter__container">
				<div class="c-newsletter__left">
					<div class="c-newsletter__heading">
						<h2>
							<slot name="heading">Nyhedsbrev</slot>
						</h2>
					</div>
					<p class="c-newsletter__text">
						<slot name="text"
							>Nyhedsbrevet vil indeholde alt fra nyhedsartikler
							til analyser, kommentare og længere rapporter fra
							havnen. Tilmed dig vores nyhedsbrev!</slot
						>
					</p>
				</div>

				<div class="c-newsletter__right">
					<div class="c-newsletter__form" v-if="!isSuccess">
						<input
							type="email"
							name="email"
							placeholder="E-mail"
							v-model="email"
						/>
						<button v-if="!isSubmitting" @click="submitForm">
							<slot name="button-text">Tilmeld</slot>
						</button>
						<button class="submit--loading" v-if="isSubmitting">
							<Spinner :white="true"></Spinner>
						</button>
					</div>
					<div
						class="c-newsletter__error"
						v-if="!isSuccess && hasSubmitted"
					>
						<p v-if="errorMessage">
							{{ errorMessage }}
						</p>
						<p v-else>Der opstod en fejl.</p>
					</div>
					<div
						class="c-newsletter__success"
						v-if="isSuccess && hasSubmitted"
					>
						<p>Tak for din tilmelding!</p>
					</div>
				</div>
			</div>

			<a class="c-newsletter__link" :href="newsPageRef">
				<slot name="link-text"> Gå til Esbjerg Havn nyheder </slot>
				<ArrowRight></ArrowRight>
			</a>
		</div>
	</aside>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

import ArrowRight from "@/assets/icon/arrow-right.svg";
import Spinner from "./Spinner.vue";

export default {
	name: "Newsletter",

	components: {
		ArrowRight,
		Spinner,
	},

	data: function () {
		return {
			consent: false,
			email: null,
			errorMessage: "",
			successMessage: "",

			isSuccess: false,
			isSubmitting: false,
			hasSubmitted: false,
		};
	},

	computed: {
		...mapState({
			csrf: (state) => state.app.csrfToken,
			siteUrl: (state) => state.app.siteUrl,
		}),
	},

	props: {
		heading: String,
		text: String,
		terms: String,
		link: String,
		linkText: String,
		button: String,
		placeholder: String,
		translations: Object,
		listId: Number,
		newsPageRef: { type: String, default: "/news" },
	},

	methods: {
		openPrivacy: function () {
			this.consent = !this.consent;
			this.$emit("openprivacy");
		},

		hideSuccess: function () {
			(this.email = null),
				(this.consent = false),
				(this.isSuccess = false);
		},

		submitForm: function () {
			this.isSubmitting = true;
			if (!this.email) {
				//Error no email
				console.log("No email");

				this.isSubmitting = false;
				return;
			}
			let formData = new FormData();
			formData.append("CRAFT_CSRF_TOKEN", this.csrf);
			formData.append(
				"action",
				"quantity-newsletter/newsletter/subscribe"
			);
			formData.append("email", this.email);
			axios
				.post(document.location.href, formData)
				.then((response) => {
					if (response.success === true) {
						this.isSuccess = response.data.success;
						this.errorMessage = response.data.msg;
					} else {
						this.isSuccess = response.data.success;
						this.errorMessage = response.data.msg;
					}
					this.isSubmitting = false;
					this.hasSubmitted = true;
				})
				.catch((error) => {
					this.isSubmitting = false;
					this.isSuccess = false;
					this.errorMessage = "Something went wrong";
					this.hasSubmitted = true;
				});

			window.dataLayer = window.dataLayer || [];

			this.isSubmitting = true;
		},
	},
};
</script>

<style lang="scss">
@import "@/scss/base/nitty.scss";
@import "@/scss/abstracts/variables.scss";

.c-newsletter {
	margin-top: -148px;
	@include grid-container();

	min-height: 296px;
	width: 100%;
	background-color: $c-orange;
	border-radius: 7px;

	&__container {
		height: 100%;

		display: flex;
		align-items: center;
		gap: 58px;

		margin-bottom: 24px;
	}

	&__wrapper {
		padding: 55px 64px;
	}

	&__left,
	&__right {
		width: 100%;
	}

	&__heading {
		padding-bottom: 19px;

		h2 {
			color: $c-blue-darkest;
			font-size: 40px;
			font-weight: $f-bold;
			line-height: 44px;
		}
	}

	&__text {
		font-size: 16px;
		line-height: 24px;
	}

	&__link {
		display: flex;
		align-items: center;
		gap: 16px;

		font-size: 16px;
		font-weight: $f-semibold;
		line-height: 23px;
		letter-spacing: 0.02em;
		color: $c-blue-darkest;

		transition: $t-hover;

		&:hover {
			text-decoration: underline;
		}
	}

	&__form {
		display: flex;
		gap: 8px;
		margin-top: 48px;

		input {
			border-radius: 7px;
			width: 100%;
			border: 1px solid $c-blue-darkest;

			padding: 11px 16px;

			background-color: $c-blue-lightest;

			color: $c-blue-darkest;
			font-size: 16px;
			line-height: 24px;

			&::placeholder {
				opacity: 1;
				font-weight: $f-regular;
				font-size: 16px;
				line-height: 24px;
				color: $c-blue-darkest;
			}
		}

		button {
			display: flex;
			align-items: center;
			justify-content: center;

			border: none;
			padding: 11px 24px;
			border-radius: 7px;

			background-color: $c-blue-darkest;
			color: $c-white;
			font-weight: $f-semibold;
			letter-spacing: 0.02em;

			cursor: pointer;
			transition: $t-hover;
			border: 2px solid transparent;

			&:hover {
				background-color: $c-orange;
				color: $c-blue-darkest;
				border: 2px solid $c-blue-darkest;
			}
		}
		.submit {
			&--loading {
				min-width: 95px;
			}
		}
	}
	&__success {
		margin-top: 50px;
		margin-left: 2px;
	}
	&__error {
		margin-top: 12px;
		margin-left: 2px;
	}
}

@media all and (max-width: 700px) {
	.c-newsletter {
		&__container {
			flex-direction: column;
			gap: 24px;
		}

		&__wrapper {
			padding: 55px 25px;
			padding-bottom: 90px;
		}

		&__form {
			margin-top: 0;
		}
	}
}
</style>
